import React from 'react';
import Draggable from 'react-draggable';
import { withHandlers } from 'recompose';
import ToolWindow from '../../ToolWindow';
import VideoPlayer from './VideoPlayer';
import VideoNavBar from './VideoNavBar';
import AdCounter from '../../../containers/tools/AdCounter';
import './VideoTool.css';

const VideoTool = ({
  user,
  mediaUrl,
  mediaIndex,
  medias,
  videoState,
  videoPosition,
  playbackRate,
  adminCheckActive,
  onLoadedMetadata,
  onTimeUpdate,
  onClose,
  onEnded,
  onPlaying,
  onPause,
  onNavigate,
  mediaDate,
  handleAdminCheckClick,
}) => {
  const adminCheckClass = adminCheckActive
    ? ' adminCheck active'
    : ' adminCheck';
  return (
    <Draggable
      handle=".header"
      bounds="parent"
      defaultPosition={{ x: 50, y: 0 }}
      position={null}
    >
      <div style={{
        overflow: 'hidden',
        width: 320,
        paddingLeft: 5,
        paddingRight: 5,
        paddingBottom: 5,
      }}
      >
        <div className="VideoTool">
          <ToolWindow
            title={(user && mediaDate + user.name.replace(user.id, '')) || 'Видео'}
            icon="fontawesome-film"
            onClose={onClose}
            actionBar={
              <div className="VideoToolActionBar">
                <button
                  className={`fontawesome-list-ol${adminCheckClass}`}
                  onClick={handleAdminCheckClick}
                />
              </div>
            }
          >
            <VideoPlayer
              url={mediaUrl}
              state={videoState}
              position={videoPosition}
              playbackRate={playbackRate}
              onLoadedMetadata={onLoadedMetadata}
              onTimeUpdate={onTimeUpdate}
              onEnded={onEnded}
              onPlaying={onPlaying}
              onPause={onPause}
            />
            <VideoNavBar
              index={medias && medias.length > 0 ? (mediaIndex + 1) : 0}
              count={medias ? medias.length : 0}
              onClick={onNavigate}
            />
          </ToolWindow>
          {adminCheckActive && <AdCounter />}
        </div>
      </div>
    </Draggable>
  );
};

export default withHandlers({
  handleAdminCheckClick: ({ adminCheckActive, onAdminCheckActive }) => () =>
    onAdminCheckActive(!adminCheckActive),
})(VideoTool);



// WEBPACK FOOTER //
// ./src/components/tools/VideoTool/VideoTool.jsx